import { Cpu } from "lucide-react";
import { AIModelPicker } from "./AIModelPicker";

export function AIModelPill({ model, availableModels, onChange, compact = false }) {
	return (
		<div className="flex items-center gap-1.5">
			<Cpu className="h-3.5 w-3.5 text-volt" aria-hidden="true" />
			<AIModelPicker
				model={model}
				availableModels={availableModels}
				onChange={onChange}
				compact={compact}
			/>
		</div>
	);
}
